import React, { useState } from "react";
import "../../styles/common/index.css"; // Common styles (PageLayout, ActionBar, FilterForm)
import "./VerificationStatus.css"; // Page-specific styles (Table, etc.)

const VerificationStatus = () => {
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  
  // Filter form state
  const [filterData, setFilterData] = useState({
    loanNo: "",
    customerName: "",
    fromDate: "",
    toDate: "",
    aadharStatus: "",
    panStatus: "",
    videoKycStatus: "",
    eSignStatus: "",
  });

  const toggleFilterForm = () => {
    setShowFilterForm(!showFilterForm);
  };

  const handleFilterChange = (field, value) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFilterSearch = () => {
    // TODO: Implement search functionality with backend
    console.log("Filter Data:", filterData);
    setShowFilterForm(false);
  };

  const handleFilterReset = () => {
    console.log("Reset button clicked!");
    
    const emptyData = {
      loanNo: "",
      customerName: "",
      fromDate: "",
      toDate: "",
      aadharStatus: "",
      panStatus: "",
      videoKycStatus: "",
      eSignStatus: "",
    };
    
    setFilterData({ ...emptyData });
    setFormKey(prev => prev + 1);
    
    console.log("Reset completed! Data:", emptyData);
  };

  // Dummy data - later replace with actual API data
  const loans = [
    {
      id: 1,
      loanNo: "DFTLVAN00000002409",
      customer: "SANJANA VIJAY TALREJA",
      disbursalAmount: "16,150",
      aadharStatus: "1",
      panStatus: "1",
      videoKycStatus: "Yes",
      eSignStatus: "Yes",
    },
    {
      id: 2,
      loanNo: "DFTLVAN00000002406",
      customer: "PRADEEP KUMAR DUBEY",
      disbursalAmount: "22,950",
      aadharStatus: "1",
      panStatus: "1",
      videoKycStatus: "Yes",
      eSignStatus: "Yes",
    },
  ];

  return (
    <div className="page-wrapper verification-status-page">
      {/* Page Header */}
      <div className="page-header-section">
        <div className="page-title-section">
          <h1 className="verification-page-title">All Verified Loan Status</h1>
          <p className="page-subtitle">View and manage verification status of all loans</p>
        </div>
      </div>

      {/* Filter Form Section */}
      {showFilterForm && (
        <div className="filter-form-section" key={formKey}>
          <form className="filter-form-container" onSubmit={(e) => e.preventDefault()}>
            {/* First Row */}
            <div className="filter-form-row">
              <div className="filter-form-field">
                <label>Loan No</label>
                <input
                  type="text"
                  value={filterData.loanNo}
                  onChange={(e) => handleFilterChange("loanNo", e.target.value)}
                  placeholder="Enter Loan No"
                />
              </div>
              <div className="filter-form-field">
                <label>Customer Name</label>
                <input
                  type="text"
                  value={filterData.customerName}
                  onChange={(e) => handleFilterChange("customerName", e.target.value)}
                  placeholder="Enter Customer Name"
                />
              </div>
              <div className="filter-form-field">
                <label>From Date</label>
                <input
                  type="date"
                  value={filterData.fromDate}
                  onChange={(e) => handleFilterChange("fromDate", e.target.value)}
                />
              </div>
              <div className="filter-form-field">
                <label>To Date</label>
                <input
                  type="date"
                  value={filterData.toDate}
                  onChange={(e) => handleFilterChange("toDate", e.target.value)}
                />
              </div>
            </div>

            {/* Second Row */}
            <div className="filter-form-row">
              <div className="filter-form-field">
                <label>Aadhar Status</label>
                <select
                  value={filterData.aadharStatus}
                  onChange={(e) => handleFilterChange("aadharStatus", e.target.value)}
                >
                  <option value="">SELECT</option>
                  <option value="1">Verified (1)</option>
                  <option value="0">Not Verified (0)</option>
                </select>
              </div>
              <div className="filter-form-field">
                <label>PAN Status</label>
                <select
                  value={filterData.panStatus}
                  onChange={(e) => handleFilterChange("panStatus", e.target.value)}
                >
                  <option value="">SELECT</option>
                  <option value="1">Verified (1)</option>
                  <option value="0">Not Verified (0)</option>
                </select>
              </div>
              <div className="filter-form-field">
                <label>Video KYC Status</label>
                <select
                  value={filterData.videoKycStatus}
                  onChange={(e) => handleFilterChange("videoKycStatus", e.target.value)}
                >
                  <option value="">SELECT</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
              <div className="filter-form-field">
                <label>E-Sign Status</label>
                <select
                  value={filterData.eSignStatus}
                  onChange={(e) => handleFilterChange("eSignStatus", e.target.value)}
                >
                  <option value="">SELECT</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="filter-form-actions">
              <button type="button" className="filter-search-btn" onClick={(e) => { e.preventDefault(); handleFilterSearch(); }}>
                SEARCH
              </button>
              <button type="button" className="filter-reset-btn" onClick={(e) => { e.preventDefault(); handleFilterReset(); }}>
                RESET
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Table Controls */}
      <div className="table-controls">
        <div className="entries-control">
          <label>Show</label>
          <select
            className="entries-select"
            value={entriesPerPage}
            onChange={(e) => setEntriesPerPage(Number(e.target.value))}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span className="entries-label">entries</span>
        </div>
        <div className="table-search">
          <label>Search:</label>
          <input
            type="text"
            className="table-search-input"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder=""
          />
        </div>
      </div>

      {/* Data Table Section */}
      <div className="data-table-section">
        <table className="leads-data-table">
          <thead>
            <tr>
              <th>Loan Number</th>
              <th>Customer</th>
              <th>Disbursal Amount</th>
              <th>Aadhar Status</th>
              <th>PAN Status</th>
              <th>Video KYC Status</th>
              <th>E-Sign Status</th>
            </tr>
          </thead>
          <tbody>
            {loans.length === 0 ? (
              <tr>
                <td colSpan="7" className="empty-state-cell">
                  <div className="empty-state">
                    <div className="empty-state-icon">📋</div>
                    <h3 className="empty-state-title">No Loans Found</h3>
                    <p className="empty-state-message">
                      There are no verified loans at the moment.
                    </p>
                  </div>
                </td>
              </tr>
            ) : (
              loans.map((loan) => (
                <tr key={loan.id}>
                  <td className="loan-no-cell">{loan.loanNo}</td>
                  <td className="customer-cell">{loan.customer}</td>
                  <td className="disbursal-amount-cell">{loan.disbursalAmount}</td>
                  <td className="aadhar-status-cell">{loan.aadharStatus}</td>
                  <td className="pan-status-cell">{loan.panStatus}</td>
                  <td className="video-kyc-status-cell">{loan.videoKycStatus}</td>
                  <td className="esign-status-cell">{loan.eSignStatus}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="pagination-section">
        <div className="pagination-info">
          Showing {loans.length > 0 ? 1 : 0} to {loans.length} of {loans.length} entries
        </div>
        <div className="pagination-controls">
          <button className="pagination-btn pagination-prev-next" disabled>
            Previous
          </button>
          <button className="pagination-btn pagination-number active">1</button>
          <button className="pagination-btn pagination-number">2</button>
          <button className="pagination-btn pagination-number">3</button>
          <button className="pagination-btn pagination-number">4</button>
          <button className="pagination-btn pagination-number">5</button>
          <button className="pagination-btn pagination-ellipsis" disabled>...</button>
          <button className="pagination-btn pagination-number">11</button>
          <button className="pagination-btn pagination-prev-next">
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationStatus;

